import { AutomationRunActionPromptType } from 'shared/types/graphql';
import { IconName } from '@televet/kibble-ui/build/components/Icon';

export interface PromptOptionDetail {
  title: string;
  type: AutomationRunActionPromptType;
  iconName: IconName;
  description: string;
}

export const promptOptionDetails: Record<AutomationRunActionPromptType, PromptOptionDetail> = {
  [AutomationRunActionPromptType.Prompt]: {
    title: 'Text Field',
    iconName: 'input',
    type: AutomationRunActionPromptType.Prompt,
    description: 'Create a text field for clients to freely respond.',
  },
  [AutomationRunActionPromptType.Form]: {
    title: 'Form',
    iconName: 'form',
    type: AutomationRunActionPromptType.Form,
    description: 'Attach a form for clients to complete and submit.',
  },
  [AutomationRunActionPromptType.Buttons]: {
    title: 'Buttons',
    iconName: 'buttons',
    type: AutomationRunActionPromptType.Buttons,
    description: 'Create a series of buttons that clients can select from.',
  },
  [AutomationRunActionPromptType.Payment]: {
    title: 'Payment',
    iconName: 'invoice',
    type: AutomationRunActionPromptType.Payment,
    description: 'Send an invoice to collect payment from a client.',
  },
  [AutomationRunActionPromptType.Statement]: {
    title: 'Statement',
    iconName: 'loudspeaker',
    type: AutomationRunActionPromptType.Statement,
    description: 'Deliver a message where no response is needed.',
  },
};

export const getPromptOptionDetailByType = (promptType?: AutomationRunActionPromptType): PromptOptionDetail => {
  if (!promptType) {
    return promptOptionDetails[AutomationRunActionPromptType.Prompt];
  }
  return promptOptionDetails[promptType];
};
